import React from "react";

import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";

import { HomeFaireMarketFooter } from "./HomeFaireMarketFooter";
import { HomeFaireMarketHero } from "./HomeFaireMarketHero";

export const HomeFaireMarketBanner: React.FC = () => {
  const { layoutElement, onCTAClick, requestId } = React.useContext(Context);
  const onClick = () => {
    onCTAClick?.(
      layoutElement.on_click_event_name ?? "HomeFaireMarketBanner",
      requestId
    );
  };
  switch (layoutElement.on_click_event_name) {
    case "homepage_market_banner_hero":
      return <HomeFaireMarketHero onClick={onClick} />;
    case "homepage_market_banner_footer":
      return <HomeFaireMarketFooter onClick={onClick} />;
    default:
      return null;
  }
};
